import { gql } from '../../../__generated__';

export const LOGIN = gql(/* GraphQL */ `
  mutation Login($input: UsersPermissionsLoginInput!) {
    login(input: $input) {
      jwt
      user {
        id
        documentId
        username
        email
        confirmed
        blocked
        role {
          id
          name
          description
          type
        }
      }
    }
  }
`);

export const SIGNUP = gql(/* GraphQL */ `
  mutation Register($input: UsersPermissionsRegisterInput!) {
    register(input: $input) {
      user {
        role {
          id
          name
          type
          description
        }
        id
        email
        username
        documentId
        confirmed
      }
      jwt
    }
  }
`);

export const FORGOT_PASSWORD = gql(/* GraphQL */ `
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      ok
    }
  }
`);

export const RESET_PASSWORD = gql(/* GraphQL */ `
  mutation ResetPassword(
    $password: String!
    $passwordConfirmation: String!
    $code: String!
  ) {
    resetPassword(
      password: $password
      passwordConfirmation: $passwordConfirmation
      code: $code
    ) {
      jwt
    }
  }
`);
